import { Link } from 'react-router-dom';
import { ArrowRight, Clock, Globe, Zap } from 'lucide-react';
import { SCRAPERS } from '@proptr/shared';
import { AppShell } from '../components/layout/AppShell.js';
import { Card } from '../components/ui/card.js';

/**
 * The scraper catalogue is static — a scraper exists because code implements
 * it, not because a row exists. Run history is the dynamic half and lives on
 * each scraper's detail page.
 */
export function ScrapersPage() {
  return (
    <AppShell>
      <div className="space-y-8">
        <div>
          <div className="eyebrow">Admin / Scrapers</div>
          <h1 className="font-display text-[40px] font-medium leading-none tracking-[-0.02em]">
            Scrapers
          </h1>
          <p className="mt-3 font-mono text-[11px] text-muted-foreground">
            Sources we pull agencies, agents and listings from.
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          {SCRAPERS.map((s) => (
            <Link
              key={s.id}
              to={`/scrapers/${s.id}`}
              className="group rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
            >
              <Card className="h-full p-5 transition-shadow group-hover:shadow-pop">
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="font-display text-[22px] font-medium leading-tight tracking-[-0.01em]">
                      {s.name}
                    </div>
                    <div className="mt-1 flex items-center gap-1.5 font-mono text-[11px] text-muted-foreground">
                      <Globe className="h-3 w-3" />
                      {s.source}
                      <span className="pill pill-muted ml-1">{s.region}</span>
                    </div>
                  </div>
                  <ArrowRight className="mt-1 h-4 w-4 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-0.5 group-hover:text-foreground" />
                </div>

                <p className="mt-3 text-[13px] leading-relaxed text-muted-foreground">
                  {s.description}
                </p>

                <div className="mt-4 space-y-2 border-t border-[hsl(var(--hairline))] pt-4">
                  {s.jobs.map((j) => (
                    <div key={j.id} className="flex items-center gap-2">
                      {j.cadence === 'scheduled' ? (
                        <Clock className="h-3.5 w-3.5 shrink-0 text-primary" />
                      ) : (
                        <Zap className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
                      )}
                      <span className="text-[13px] font-medium">{j.name}</span>
                      <span
                        className={
                          j.cadence === 'scheduled'
                            ? 'pill pill-accent'
                            : 'pill pill-muted'
                        }
                      >
                        {j.cadence === 'scheduled' ? 'Scheduled' : 'Once per agency'}
                      </span>
                    </div>
                  ))}
                </div>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </AppShell>
  );
}
